export class ListInfectedExcludePathsResponse {
    'paths';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "paths",
            "baseName": "paths",
            "type": "Array<InfectedExcludePath>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInfectedExcludePathsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
